import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { MuiSelect, MuiTextField, MuiButton } from '../../../../../components'
import questionManagement from '../../../../../services/questionManagement.service'
import { useGlobalStore } from '../../../../../store'
import { consoleLog, getObjectAsArray } from '../../../../../util'
import { OuterWrapper, ButtonWrapper, Message } from './style'

const Add = ({ onChange, rowData, editSettings }) => {
  const { company } = useGlobalStore()
  // const strAddNew = 'Add New...'
  const initialFormObj = {
    questionA: '', // strAddNew,
    questionB: '', // strAddNew,
    questionC: '',
    questionD: '',
    questionE: '',
    questionF: '',
    questionG: '',
    questionH: '',
    questionI: '',
    questionJ: ''
  }

  const showDropdown1Array = ['itemQuestion1', 'itemQuestion3', 'localQuestion1', 'localQuestion3']
  const showDropdown2Array = showDropdown1Array

  const form = useRef()

  const [formData, setFormData] = useState(initialFormObj)
  // const [formError, setFormError] = useState('')
  // const [formSuccess, setFormSuccess] = useState('')
  const [messages, setMessages] = useState(null)
  const [formSelectData, setFormSelectData] = useState({
    questionA: [],
    questionB: []
  })

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = []
    if (formData?.questionA) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question A', SubPropertyValue: formData?.questionA || '' } }) }
    if (formData?.questionB) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question B', SubPropertyValue: formData?.questionB || '' } }) }
    if (formData?.questionC) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question C', SubPropertyValue: formData?.questionC || '' } }) }
    if (formData?.questionD) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question D', SubPropertyValue: formData?.questionD || '' } }) }
    if (formData?.questionE) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question E', SubPropertyValue: formData?.questionE || '' } }) }
    if (formData?.questionF) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question F', SubPropertyValue: formData?.questionF || '' } }) }
    if (formData?.questionG) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question G', SubPropertyValue: formData?.questionG || '' } }) }
    if (formData?.questionH) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question H', SubPropertyValue: formData?.questionH || '' } }) }
    if (formData?.questionI) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question I', SubPropertyValue: formData?.questionI || '' } }) }
    if (formData?.questionJ) { obj.push({ SubPropertyNameValue: { SubPropertyName: 'Question J', SubPropertyValue: formData?.questionJ || '' } }) }

    const payload = {
      // propertyName: rowData.QuestionValue,
      propertyName: (editSettings.type).toLowerCase().replace('item', '').replace('question', 'Question ').replace('local', 'Local '),
      propertyValue: rowData.QuestionValue,
      subPropertyNameValues: obj
    }

    questionManagement.setAggregationItemSubPropertyNameValuesApi(payload)
      .then(resp => {
        setMessages({ type: 'success', msg: 'Done !!' })
      })
      .catch(error => {
        setMessages({ type: 'error', msg: 'Something went wrong !!' })
        consoleLog('error - ', error)
      })

    // setFormSuccess('Data added successfully')
    resetForm()
  }

  const onload = async () => {
    try {
      if (showDropdown1Array.includes(editSettings.type)) {
        const payload = { organizationId: company?.OrganizationId }

        const questionA_Api = await questionManagement.getOrganizationAggregationQuestion1AApi(payload, editSettings.type)
        const questionA_Array = getObjectAsArray(questionA_Api, 'adv')?.map(d => ({ label: d, value: d })) || []
        // questionA_Array.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })

        const questionB_Api = await questionManagement.getOrganizationAggregationQuestion1BApi(payload, editSettings.type)
        const questionB_Array = getObjectAsArray(questionB_Api, 'adv')?.map(d => ({ label: d, value: d })) || []
        // questionB_Array.push({ label: ' ', value: ' ', valKeywordValue: ' ', valKeywordId: ' ', valKeywordSearchTerm: ' ' })

        setFormSelectData(prev => ({ ...prev, questionA: questionA_Array, questionB: questionB_Array }))
      }

      // const questionData = await questionManagement.getAggregationItemSubPropertyNameValuesApi({ propertyName: rowData.QuestionValue, propertyValue: rowData.QuestionValue })
      const propertyName = (editSettings.type).toLowerCase().replace('item', '').replace('question', 'Question ').replace('local', 'Local ')
      const questionData = getObjectAsArray(await questionManagement.getAggregationItemSubPropertyNameValuesApi({ propertyName, propertyValue: rowData.QuestionValue }))
      const questionObject = {}

      for (let i = 0; i < questionData.length; i++) {
        questionObject[questionData[i].SubPropertyName.replace('Question ', 'question')] = (questionData[i]?.SubPropertyValue === 'undefined') ? '' : questionData[i]?.SubPropertyValue + ''
      }
      // const arr = Object.keys(questionData)
      // for (let i = 0; i < arr.length; i++) {
      //   const key = arr[i].replace('Question ', 'question').replace('Local ', 'local')
      //   questionObject[key] = questionData[key]
      // }

      setFormData(questionObject)
    } catch (error) {
      consoleLog('error = ', error)
    }
  }

  const resetForm = () => {
    // setFormData(initialFormObj)
    setMessages(null)
    // setFormError('')
    // setFormSuccess('')
    // onload()
  }

  useEffect(() => {
    if (company?.OrganizationId) onload()
  }, [company?.OrganizationId])

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload} autoComplete='on'>
        <Grid container spacing={2}>
        <Grid item xs={3}>
          { showDropdown1Array.includes(editSettings.type)
            ? <MuiSelect
                data={formSelectData.questionA}
                name='questionA'
                placeholder='Question A'
                label='Question A'
                onChange={(e) => onChangeHandler('questionA', e.target.value)}
                variant='standard'
                value={formData.questionA}
              />
            : <MuiTextField
                name='questionA'
                placeholder='Question A'
                label='Question A'
                onChange={(e) => onChangeHandler('questionA', e.target.value)}
                variant='standard'
                value={formData?.questionA || ''}
              />
            }
          </Grid>
          <Grid item xs={3}>
          { showDropdown2Array.includes(editSettings.type)
            ? <MuiSelect
              data={formSelectData.questionB}
              name='questionB'
              placeholder='Question B'
              label='Question B'
              onChange={(e) => onChangeHandler('questionB', e.target.value)}
              variant='standard'
              value={formData.questionB || ''}
            />
            : <MuiTextField
                name='questionB'
                placeholder='Question B'
                label='Question B'
                onChange={(e) => onChangeHandler('questionB', e.target.value)}
                variant='standard'
                value={formData?.questionB || ''}
              />
            }
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionC'
              placeholder='Question C'
              label='Question C'
              onChange={(e) => onChangeHandler('questionC', e.target.value)}
              variant='standard'
              value={formData?.questionC || ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionD'
              placeholder='Question D'
              label='Question D'
              onChange={(e) => onChangeHandler('questionD', e.target.value)}
              variant='standard'
              value={formData?.questionD || ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionE'
              placeholder='Question E'
              label='Question E'
              onChange={(e) => onChangeHandler('questionE', e.target.value)}
              variant='standard'
              value={formData?.questionE || ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionF'
              placeholder='Question F'
              label='Question F'
              onChange={(e) => onChangeHandler('questionF', e.target.value)}
              variant='standard'
              value={formData?.questionF || ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionG'
              placeholder='Question G'
              label='Question G'
              onChange={(e) => onChangeHandler('questionG', e.target.value)}
              variant='standard'
              value={formData?.questionG || ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionH'
              placeholder='Question H'
              label='Question H'
              onChange={(e) => onChangeHandler('questionH', e.target.value)}
              variant='standard'
              value={formData?.questionH || ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionI'
              placeholder='Question I'
              label='Question I'
              onChange={(e) => onChangeHandler('questionI', e.target.value)}
              variant='standard'
              value={formData?.questionI || ''}
            />
          </Grid>
          <Grid item xs={3}>
            <MuiTextField
              name='questionJ'
              placeholder='Question J'
              label='Question J'
              onChange={(e) => onChangeHandler('questionJ', e.target.value)}
              variant='standard'
              value={formData?.questionJ || ''}
            />
          </Grid>
          <Grid item xs={13} style={{ justifyContent: 'space-between', display: 'flex' }}>
            <ButtonWrapper>
              <Message align='right' type={messages?.type}>{messages?.msg || ''}</Message>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px', marginLeft: '20px' }}
              >
                Save
              </MuiButton>
              {/* <MuiButton
                onClick={() => onChange()}
                type='button'
                color='primary'
                variant='contained'
                style={{ width: '120px' }}
              >
                Cancel
              </MuiButton> */}
            </ButtonWrapper>
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func,
  editSettings: PropTypes.object,
  rowData: PropTypes.object
}

export default Add
